import React, { useEffect, useState } from "react";
import APopover from "../../../../common/a-popover";
import { IoEyeOutline } from "react-icons/io5";
import { Col, Row } from "reactstrap";
import {
  fetchApplications,
  getCourseAttributes,
  getCourseDetailsV2,
} from "../../service";
import AButton from "../../../../common/form-fields-mui/AButton";
import ALoader from "../../../../common/a-loader";
import { getFormattedDate } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const CourseDetailsModal = ({
  applicationData,
  closeForm,
  isCollection = false,
}) => {
  const {
    applicationId,
    courseId,
    termDispValue,
    termDispVal,
    term,
    termId,
    psid,
    buId,
  } = applicationData || {};
  const [courseDetails, setCourseDetails] = useState({});
  const [studentClass, setStudentClass] = useState(null);
  const [courseAttribute, setCourseAttribute] = useState({
    crctValue: null,
    courseEndDate: "",
  });
  const [apiLoader, setApiLoader] = useState(false);
  const fetchCourseDetails = async () => {
    setApiLoader(true);
    const res = await getCourseDetailsV2(courseId);
    setCourseDetails(res);
    setApiLoader(false);
  };

  useEffect(() => {
    fetchCourseDetails();
  }, []);

  useEffect(() => {
    if (psid && applicationId)
      fetchApplications(psid, applicationId, setStudentClass);
  }, [psid, applicationId]);

  useEffect(() => {
    if (psid && applicationId) {
      const course = {
        courseId: courseId,
        businessArea: buId,
        term: termId,
      };

      const request = { dtoList: [course] };

      getCourseAttributes(request, setCourseAttribute);
    }
  }, [psid, applicationId]);

  const width = isCollection?'750px':'550px'

  return (
    <div
      className="color-grey-90 px-3 pt-3"
      style={{ width: width, height: "200px", overflowY: "auto" }}
    >
      {apiLoader && <ALoader />}
      <div className="d-flex flex-column h-100">
        <div className="large-semi-bold">Application no. {applicationId}</div>
        <Row className="semi-bold mt-2">
          <Col md="2" className="text-bold">Course ID</Col>
          <Col md="5" className="text-bold">Course name</Col>

          {!isCollection && <Col md="3">Term</Col>}
          {isCollection && (
            <Col md="1" className="text-bold">
              Class
            </Col>
          )}
          {isCollection && (
            <Col md="2" className="text-bold">
              Attribute
            </Col>
          )}
          {isCollection && (
            <Col md="2" className="text-bold">
              Course End Date
            </Col>
          )}
        </Row>
        <Row className="semi-bold mt-1 flex-grow-1">
          <Col md="2">{courseId}</Col>
          <Col md="5">
            {apiLoader ? "Loading..." : courseDetails?.courseName || "-"}
          </Col>
          {!isCollection && (
            <Col md="3">{termDispValue || termDispVal || term}</Col>
          )}
          {isCollection && <Col md="1"> {studentClass}</Col>}
          {isCollection && (
            <Col md="2"> {courseAttribute?.crctValue || "-"}</Col>
          )}
          {isCollection && (
            <Col md="2">
              {getFormattedDate(courseAttribute?.courseEndDate) || "-"}
            </Col>
          )}
        </Row>
        <AButton
          className="btn-left-0 mt-2 align-self-start"
          variant="primary_filled"
          size="xs"
          onClick={() => closeForm()}
        >
          Ok, got it!
        </AButton>
        <div className="pt-3"></div>{" "}
        {/* this div is added to take care of bottom padding when content is overflowing */}
      </div>
    </div>
  );
};
const MarkEligibleCourseDetailsPopup = ({
  applicationData,
  Icon = IoEyeOutline,
  isCollection,
}) => {
  const { applicationId } = applicationData || {};
  return applicationId ? (
    <div className="ml-2">
      <APopover
        transformOriginHorizontal="center"
        anchorOriginHorizontal="center"
        buttonComponent={(onclick) => (
          <Icon className="cursor" onClick={onclick} size={18} />
        )}
        menuComponent={(closeForm) => (
          <CourseDetailsModal
            applicationData={applicationData}
            closeForm={closeForm}
            isCollection={isCollection}
          />
        )}
      />
    </div>
  ) : (
    <></>
  );
};

export default MarkEligibleCourseDetailsPopup;
